import { ApexOptions } from "apexcharts"
import ReactApexChart from "react-apexcharts"

interface IData {
  username: string
  average_item_separate: number
  total_items?: number
  isAboveAverage?: boolean
}

interface ITimePerItemProps {
  data: IData[]
  AverageTimeItem: number
  title?: string
  onBarClick?: (separatorData: {
    username: string
    avg_secs: number
    total_items: number
    total_secs: number
    timeline: any[]
  }) => void
}

const TimePerItem = ({ data, AverageTimeItem, title = "Performance Individual dos Separadores", onBarClick }: ITimePerItemProps) => {

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
      fontFamily: 'Public Sans, sans-serif',
      selection: {
        enabled: !!onBarClick
      },
      events: {
        dataPointSelection: function(event, chartContext, config) {
          if (onBarClick) {
            const dataPointIndex = config.dataPointIndex
            const user = data[dataPointIndex]

            if (user) {
              onBarClick({
                username: user.username,
                avg_secs: user.average_item_separate,
                total_items: user.total_items || 0,
                total_secs: (user.average_item_separate * (user.total_items || 0)),
                timeline: [] // Será preenchido pelo componente pai
              })
            }
          }
        }
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: data.length > 20 ? '95%' : data.length > 10 ? '80%' : '60%',
        borderRadius: 4,
        dataLabels: {
          position: 'top',
        },
      },
    },
    dataLabels: {
      enabled: data.length <= 15,
      formatter: (val: number) => `${val}s`,
      offsetY: -20,
      style: {
        fontSize: '11px',
        fontWeight: 600,
        colors: ['#111827'],
      },
    },
    xaxis: {
      categories: data.map(user => user.username.split('.').join(' ')),
      labels: {
        rotate: data.length > 8 ? -45 : data.length > 5 ? -30 : 0,
        style: { fontSize: '11px' },
        maxHeight: data.length > 8 ? 80 : 60,
        trim: false,
        hideOverlappingLabels: false,
      },
    },
    yaxis: {
      min: 0,
      max:
        data.reduce(
          (acc, current) =>
            current.average_item_separate > acc ? current.average_item_separate : acc,
          0,
        ) + 30,
      decimalsInFloat: 0,
      title: {
        text: 'Tempo Médio (segundos)',
        style: { fontSize: '12px', fontWeight: 600 },
      },
    },
    colors: ['#11998e'],
    grid: {
      borderColor: '#f1f1f1',
      strokeDashArray: 4,
    },
    tooltip: {
      y: {
        formatter: (val: number) => `${val} segundos`,
      },
      custom: function({ series, seriesIndex, dataPointIndex, w }) {
        const user = data[dataPointIndex]
        if (!user) return ''

        return `
          <div style="padding: 10px;">
            <strong>${user.username}</strong><br/>
            Tempo médio: <strong>${user.average_item_separate} s</strong><br/>
            Itens processados: <strong>${user.total_items || 0}</strong><br/>
            Status: <strong style="color: #1976d2">
              ${user.isAboveAverage ? 'Acima da média' : 'Abaixo da média'}
            </strong>
          </div>
        `
      }
    },
    annotations: {
      yaxis: [
        {
          y: AverageTimeItem,
          borderColor: '#383B40',
          strokeDashArray: 6,
          borderWidth: 2,
          label: {
            borderColor: '#383B40',
            style: {
              color: '#fff',
              background: '#383B40',
            },
            text: `${AverageTimeItem}s`,
          },
        },
      ],
    },
  }

  const series: ApexOptions['series'] = [
    {
      name: 'Tempo médio por separador em segundos',
      data: data.map((user: IData) => user.average_item_separate),
    },
  ]

  return (
    <div>
      {title && (
        <h3 style={{ marginBottom: '20px', fontWeight: 600 }}>
          {title}
        </h3>
      )}
      {onBarClick && (
        <p style={{
          margin: 0,
          marginBottom: '16px',
          fontSize: '13px',
          color: '#666',
          fontStyle: 'italic',
          display: 'flex',
          alignItems: 'center',
          gap: '4px'
        }}>
          💡 Clique nas barras para ver a análise detalhada de cada separador
        </p>
      )}
      <div style={{
        paddingBottom: data.length > 8 ? '40px' : '20px',
        ...(onBarClick && {
          cursor: 'pointer',
          borderRadius: '8px',
          transition: 'all 0.2s ease'
        })
      }}>
        <ReactApexChart options={options} series={series} type="bar" height={350} />
      </div>
    </div>
  )
}

export default TimePerItem

